import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, Timestamp } from 'firebase/firestore';
import { firestore } from './config';
import type { Category } from '../types/game';

const categoriesCollection = collection(firestore, 'categories');

export const categoryService = {
  async getCategories(): Promise<Category[]> {
    const snapshot = await getDocs(categoriesCollection);
    return snapshot.docs.map(docSnap => ({ id: docSnap.id, ...docSnap.data() })) as Category[];
  },

  async addCategory(data: { name: string; description: string }): Promise<string> {
    const now = Timestamp.now();
    const docRef = await addDoc(categoriesCollection, {
      ...data,
      createdAt: now,
      updatedAt: now,
    });
    return docRef.id;
  },

  async updateCategory(id: string, data: { name?: string; description?: string; isActive?: boolean }) {
    const now = Timestamp.now();
    await updateDoc(doc(categoriesCollection, id), {
      ...data,
      updatedAt: now,
    });
  },

  async deleteCategory(id: string) {
    await deleteDoc(doc(categoriesCollection, id));
  },
}; 